import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { FieldMasterDataPathIds } from '../../content/field-master-data/field-master-data.component';

@Injectable({
  providedIn: 'root',
})
export class FieldMasterDataRoutingService {
  private readonly router = inject(Router);

  public routeToTabPartsAgreement(): void {
    this.router.navigate([`/${FieldMasterDataPathIds.FieldMasterData}/${FieldMasterDataPathIds.PartsAgreements}`]);
  }

  public routeToTabCreateFactor(): void {
    this.router.navigate([`/${FieldMasterDataPathIds.FieldMasterData}/${FieldMasterDataPathIds.AddPartsAgreement}`]);
  }
}
